import React from "react";
import Button, { ButtonSizes, ButtonThemes } from "../../../ui-components/button/button";
import "./pendingPaymentNotice.scss";

interface PendingPaymentNoticeProps {
  onCheckStatus: () => void;
  title?: string;
  text?: string;
}

const PendingPaymentNotice: React.FC<PendingPaymentNoticeProps> = ({
  onCheckStatus,
  title = "Payment in progress",
  text = "If you already finished on the card page, this invoice updates when confirmation arrives.",
}) => {
  return (
    <div className="xgs-pending-payment" role="status">
      <div className="xgs-pending-payment__copy">
        <div className="xgs-pending-payment__title">{title}</div>
        <p className="xgs-pending-payment__text">{text}</p>
      </div>
      <Button
        type="button"
        theme={ButtonThemes.blue}
        size={ButtonSizes.medium}
        onClick={onCheckStatus}
      >
        Check status
      </Button>
    </div>
  );
};

export default PendingPaymentNotice;
